export default "__VITE_PUBLIC_ASSET__92ccfe91__"